module.exports = __webpack_public_path__ + "static/img/school-1.f923322.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/school-1.png
// module id = +cvm
// module chunks = 0